
import { defineComponent, computed, defineAsyncComponent } from 'vue'
import { useI18n } from 'vue-i18n'

// Lazy load components
const ContactButton = defineAsyncComponent(() => import('./ContactButton.vue'))
const AdvantageItem = defineAsyncComponent(() => import('./AdvantageItem.vue'))

export default defineComponent({
  name: 'AdvantagesSection',
  components: {
    ContactButton,
    AdvantageItem,
  },
  setup() {
    const { t, tm } = useI18n()

    // Pre-compute advantages list
    const advantagesList = computed(() => {
      const itemsObj = tm('landingMTShop.advantages.items') as Record<
        string,
        any
      >
      return Object.values(itemsObj)
    })

    return {
      t,
      advantagesList,
    }
  },
})
